import {
  FETCH_FORM_FAIL,
  FETCH_FORM_REQUEST,
  FETCH_FORM_SUCCESS,
} from "../../ActionType/FormType/FormType";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getFormAction = (ids) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params:{
      ids
    }
  };
  
  dispatch({
    type: FETCH_FORM_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("form", config);
    const { status, data } = response;
    
    
    if (status == 200) {
      dispatch({
        type: FETCH_FORM_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_FORM_FAIL,
      payload: [],
    });
  }
};
